import { render, staticRenderFns } from "./structure.vue?vue&type=template&id=7dafd48b&scoped=true&"
import script from "./structure.vue?vue&type=script&lang=js&"
export * from "./structure.vue?vue&type=script&lang=js&"
import style0 from "./structure.vue?vue&type=style&index=0&id=7dafd48b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dafd48b",
  null
  
)

export default component.exports